module.exports = __webpack_public_path__ + "img/219c9d6.png";